import { Flex, Heading, SimpleGrid } from '@chakra-ui/react';
import StatCard from '@features/explore/StatCard';

const TradingActivity = () => {
  return (
    <Flex direction="column" gap={4}>
      <Heading>Trading Activity</Heading>
      <SimpleGrid columns={{ base: 1, md: 4 }} gap={4}>
        <StatCard label="Number of buyers" value="100" tooltipContent="Some info" />
        <StatCard label="Number of sellers" value="5" tooltipContent="Some info" />
        <StatCard label="Unique traders" value="105" tooltipContent="Some info" />
      </SimpleGrid>
    </Flex>
  );
};

export default TradingActivity;
